"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ParamsV280 = exports.ParamsV270 = exports.protobufPackage = void 0;
/* eslint-disable */
const long_1 = __importDefault(require("long"));
const minimal_1 = __importDefault(require("protobufjs/minimal"));
const duration_1 = require("../google/protobuf/duration");
exports.protobufPackage = "Switcheo.carbon.market";
const baseParamsV270 = {
    defaultLotSizeUsd: "",
    defaultTickSizeUsd: "",
    defaultMinQuantityUsd: "",
    defaultSpotMakerFee: "",
    defaultSpotTakerFee: "",
    defaultFuturesMakerFee: "",
    defaultFuturesTakerFee: "",
    defaultRiskStepSizeUsd: "",
    defaultInitialMarginBase: "",
    defaultInitialMarginStep: "",
    defaultMaintenanceMarginRatio: "",
    defaultMaxLiquidationOrderTicketUsd: "",
    defaultImpactSizeUsd: "",
    defaultMarkPriceBand: 0,
    defaultLastPriceProtectedBand: 0,
    maxActiveMarkets: 0,
};
exports.ParamsV270 = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.defaultLotSizeUsd !== "") {
            writer.uint32(10).string(message.defaultLotSizeUsd);
        }
        if (message.defaultTickSizeUsd !== "") {
            writer.uint32(18).string(message.defaultTickSizeUsd);
        }
        if (message.defaultMinQuantityUsd !== "") {
            writer.uint32(26).string(message.defaultMinQuantityUsd);
        }
        if (message.defaultSpotMakerFee !== "") {
            writer.uint32(34).string(message.defaultSpotMakerFee);
        }
        if (message.defaultSpotTakerFee !== "") {
            writer.uint32(42).string(message.defaultSpotTakerFee);
        }
        if (message.defaultFuturesMakerFee !== "") {
            writer.uint32(50).string(message.defaultFuturesMakerFee);
        }
        if (message.defaultFuturesTakerFee !== "") {
            writer.uint32(58).string(message.defaultFuturesTakerFee);
        }
        if (message.defaultRiskStepSizeUsd !== "") {
            writer.uint32(66).string(message.defaultRiskStepSizeUsd);
        }
        if (message.defaultInitialMarginBase !== "") {
            writer.uint32(74).string(message.defaultInitialMarginBase);
        }
        if (message.defaultInitialMarginStep !== "") {
            writer.uint32(82).string(message.defaultInitialMarginStep);
        }
        if (message.defaultMaintenanceMarginRatio !== "") {
            writer.uint32(90).string(message.defaultMaintenanceMarginRatio);
        }
        if (message.defaultMaxLiquidationOrderTicketUsd !== "") {
            writer.uint32(98).string(message.defaultMaxLiquidationOrderTicketUsd);
        }
        if (message.defaultMaxLiquidationOrderDuration !== undefined) {
            duration_1.Duration.encode(message.defaultMaxLiquidationOrderDuration, writer.uint32(106).fork()).ldelim();
        }
        if (message.defaultImpactSizeUsd !== "") {
            writer.uint32(114).string(message.defaultImpactSizeUsd);
        }
        if (message.defaultMarkPriceBand !== 0) {
            writer.uint32(120).uint32(message.defaultMarkPriceBand);
        }
        if (message.defaultLastPriceProtectedBand !== 0) {
            writer.uint32(128).uint32(message.defaultLastPriceProtectedBand);
        }
        if (message.maxActiveMarkets !== 0) {
            writer.uint32(136).uint32(message.maxActiveMarkets);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseParamsV270);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.defaultLotSizeUsd = reader.string();
                    break;
                case 2:
                    message.defaultTickSizeUsd = reader.string();
                    break;
                case 3:
                    message.defaultMinQuantityUsd = reader.string();
                    break;
                case 4:
                    message.defaultSpotMakerFee = reader.string();
                    break;
                case 5:
                    message.defaultSpotTakerFee = reader.string();
                    break;
                case 6:
                    message.defaultFuturesMakerFee = reader.string();
                    break;
                case 7:
                    message.defaultFuturesTakerFee = reader.string();
                    break;
                case 8:
                    message.defaultRiskStepSizeUsd = reader.string();
                    break;
                case 9:
                    message.defaultInitialMarginBase = reader.string();
                    break;
                case 10:
                    message.defaultInitialMarginStep = reader.string();
                    break;
                case 11:
                    message.defaultMaintenanceMarginRatio = reader.string();
                    break;
                case 12:
                    message.defaultMaxLiquidationOrderTicketUsd = reader.string();
                    break;
                case 13:
                    message.defaultMaxLiquidationOrderDuration = duration_1.Duration.decode(reader, reader.uint32());
                    break;
                case 14:
                    message.defaultImpactSizeUsd = reader.string();
                    break;
                case 15:
                    message.defaultMarkPriceBand = reader.uint32();
                    break;
                case 16:
                    message.defaultLastPriceProtectedBand = reader.uint32();
                    break;
                case 17:
                    message.maxActiveMarkets = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseParamsV270);
        message.defaultLotSizeUsd =
            object.defaultLotSizeUsd !== undefined &&
                object.defaultLotSizeUsd !== null
                ? String(object.defaultLotSizeUsd)
                : "";
        message.defaultTickSizeUsd =
            object.defaultTickSizeUsd !== undefined &&
                object.defaultTickSizeUsd !== null
                ? String(object.defaultTickSizeUsd)
                : "";
        message.defaultMinQuantityUsd =
            object.defaultMinQuantityUsd !== undefined &&
                object.defaultMinQuantityUsd !== null
                ? String(object.defaultMinQuantityUsd)
                : "";
        message.defaultSpotMakerFee =
            object.defaultSpotMakerFee !== undefined &&
                object.defaultSpotMakerFee !== null
                ? String(object.defaultSpotMakerFee)
                : "";
        message.defaultSpotTakerFee =
            object.defaultSpotTakerFee !== undefined &&
                object.defaultSpotTakerFee !== null
                ? String(object.defaultSpotTakerFee)
                : "";
        message.defaultFuturesMakerFee =
            object.defaultFuturesMakerFee !== undefined &&
                object.defaultFuturesMakerFee !== null
                ? String(object.defaultFuturesMakerFee)
                : "";
        message.defaultFuturesTakerFee =
            object.defaultFuturesTakerFee !== undefined &&
                object.defaultFuturesTakerFee !== null
                ? String(object.defaultFuturesTakerFee)
                : "";
        message.defaultRiskStepSizeUsd =
            object.defaultRiskStepSizeUsd !== undefined &&
                object.defaultRiskStepSizeUsd !== null
                ? String(object.defaultRiskStepSizeUsd)
                : "";
        message.defaultInitialMarginBase =
            object.defaultInitialMarginBase !== undefined &&
                object.defaultInitialMarginBase !== null
                ? String(object.defaultInitialMarginBase)
                : "";
        message.defaultInitialMarginStep =
            object.defaultInitialMarginStep !== undefined &&
                object.defaultInitialMarginStep !== null
                ? String(object.defaultInitialMarginStep)
                : "";
        message.defaultMaintenanceMarginRatio =
            object.defaultMaintenanceMarginRatio !== undefined &&
                object.defaultMaintenanceMarginRatio !== null
                ? String(object.defaultMaintenanceMarginRatio)
                : "";
        message.defaultMaxLiquidationOrderTicketUsd =
            object.defaultMaxLiquidationOrderTicketUsd !== undefined &&
                object.defaultMaxLiquidationOrderTicketUsd !== null
                ? String(object.defaultMaxLiquidationOrderTicketUsd)
                : "";
        message.defaultMaxLiquidationOrderDuration =
            object.defaultMaxLiquidationOrderDuration !== undefined &&
                object.defaultMaxLiquidationOrderDuration !== null
                ? duration_1.Duration.fromJSON(object.defaultMaxLiquidationOrderDuration)
                : undefined;
        message.defaultImpactSizeUsd =
            object.defaultImpactSizeUsd !== undefined &&
                object.defaultImpactSizeUsd !== null
                ? String(object.defaultImpactSizeUsd)
                : "";
        message.defaultMarkPriceBand =
            object.defaultMarkPriceBand !== undefined &&
                object.defaultMarkPriceBand !== null
                ? Number(object.defaultMarkPriceBand)
                : 0;
        message.defaultLastPriceProtectedBand =
            object.defaultLastPriceProtectedBand !== undefined &&
                object.defaultLastPriceProtectedBand !== null
                ? Number(object.defaultLastPriceProtectedBand)
                : 0;
        message.maxActiveMarkets =
            object.maxActiveMarkets !== undefined && object.maxActiveMarkets !== null
                ? Number(object.maxActiveMarkets)
                : 0;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.defaultLotSizeUsd !== undefined &&
            (obj.defaultLotSizeUsd = message.defaultLotSizeUsd);
        message.defaultTickSizeUsd !== undefined &&
            (obj.defaultTickSizeUsd = message.defaultTickSizeUsd);
        message.defaultMinQuantityUsd !== undefined &&
            (obj.defaultMinQuantityUsd = message.defaultMinQuantityUsd);
        message.defaultSpotMakerFee !== undefined &&
            (obj.defaultSpotMakerFee = message.defaultSpotMakerFee);
        message.defaultSpotTakerFee !== undefined &&
            (obj.defaultSpotTakerFee = message.defaultSpotTakerFee);
        message.defaultFuturesMakerFee !== undefined &&
            (obj.defaultFuturesMakerFee = message.defaultFuturesMakerFee);
        message.defaultFuturesTakerFee !== undefined &&
            (obj.defaultFuturesTakerFee = message.defaultFuturesTakerFee);
        message.defaultRiskStepSizeUsd !== undefined &&
            (obj.defaultRiskStepSizeUsd = message.defaultRiskStepSizeUsd);
        message.defaultInitialMarginBase !== undefined &&
            (obj.defaultInitialMarginBase = message.defaultInitialMarginBase);
        message.defaultInitialMarginStep !== undefined &&
            (obj.defaultInitialMarginStep = message.defaultInitialMarginStep);
        message.defaultMaintenanceMarginRatio !== undefined &&
            (obj.defaultMaintenanceMarginRatio =
                message.defaultMaintenanceMarginRatio);
        message.defaultMaxLiquidationOrderTicketUsd !== undefined &&
            (obj.defaultMaxLiquidationOrderTicketUsd =
                message.defaultMaxLiquidationOrderTicketUsd);
        message.defaultMaxLiquidationOrderDuration !== undefined &&
            (obj.defaultMaxLiquidationOrderDuration =
                message.defaultMaxLiquidationOrderDuration
                    ? duration_1.Duration.toJSON(message.defaultMaxLiquidationOrderDuration)
                    : undefined);
        message.defaultImpactSizeUsd !== undefined &&
            (obj.defaultImpactSizeUsd = message.defaultImpactSizeUsd);
        message.defaultMarkPriceBand !== undefined &&
            (obj.defaultMarkPriceBand = message.defaultMarkPriceBand);
        message.defaultLastPriceProtectedBand !== undefined &&
            (obj.defaultLastPriceProtectedBand =
                message.defaultLastPriceProtectedBand);
        message.maxActiveMarkets !== undefined &&
            (obj.maxActiveMarkets = message.maxActiveMarkets);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
        const message = Object.assign({}, baseParamsV270);
        message.defaultLotSizeUsd = (_a = object.defaultLotSizeUsd) !== null && _a !== void 0 ? _a : "";
        message.defaultTickSizeUsd = (_b = object.defaultTickSizeUsd) !== null && _b !== void 0 ? _b : "";
        message.defaultMinQuantityUsd = (_c = object.defaultMinQuantityUsd) !== null && _c !== void 0 ? _c : "";
        message.defaultSpotMakerFee = (_d = object.defaultSpotMakerFee) !== null && _d !== void 0 ? _d : "";
        message.defaultSpotTakerFee = (_e = object.defaultSpotTakerFee) !== null && _e !== void 0 ? _e : "";
        message.defaultFuturesMakerFee = (_f = object.defaultFuturesMakerFee) !== null && _f !== void 0 ? _f : "";
        message.defaultFuturesTakerFee = (_g = object.defaultFuturesTakerFee) !== null && _g !== void 0 ? _g : "";
        message.defaultRiskStepSizeUsd = (_h = object.defaultRiskStepSizeUsd) !== null && _h !== void 0 ? _h : "";
        message.defaultInitialMarginBase = (_j = object.defaultInitialMarginBase) !== null && _j !== void 0 ? _j : "";
        message.defaultInitialMarginStep = (_k = object.defaultInitialMarginStep) !== null && _k !== void 0 ? _k : "";
        message.defaultMaintenanceMarginRatio =
            (_l = object.defaultMaintenanceMarginRatio) !== null && _l !== void 0 ? _l : "";
        message.defaultMaxLiquidationOrderTicketUsd =
            (_m = object.defaultMaxLiquidationOrderTicketUsd) !== null && _m !== void 0 ? _m : "";
        message.defaultMaxLiquidationOrderDuration =
            object.defaultMaxLiquidationOrderDuration !== undefined &&
                object.defaultMaxLiquidationOrderDuration !== null
                ? duration_1.Duration.fromPartial(object.defaultMaxLiquidationOrderDuration)
                : undefined;
        message.defaultImpactSizeUsd = (_o = object.defaultImpactSizeUsd) !== null && _o !== void 0 ? _o : "";
        message.defaultMarkPriceBand = (_p = object.defaultMarkPriceBand) !== null && _p !== void 0 ? _p : 0;
        message.defaultLastPriceProtectedBand =
            (_q = object.defaultLastPriceProtectedBand) !== null && _q !== void 0 ? _q : 0;
        message.maxActiveMarkets = (_r = object.maxActiveMarkets) !== null && _r !== void 0 ? _r : 0;
        return message;
    },
};
const baseParamsV280 = {
    defaultLotSizeUsd: "",
    defaultTickSizeUsd: "",
    defaultMinQuantityUsd: "",
    defaultSpotMakerFee: "",
    defaultSpotTakerFee: "",
    defaultFuturesMakerFee: "",
    defaultFuturesTakerFee: "",
    defaultRiskStepSizeUsd: "",
    defaultInitialMarginBase: "",
    defaultInitialMarginStep: "",
    defaultMaintenanceMarginRatio: "",
    defaultMaxLiquidationOrderTicketUsd: "",
    defaultImpactSizeUsd: "",
    defaultMarkPriceBand: 0,
    defaultLastPriceProtectedBand: 0,
    maxActiveMarkets: 0,
    defaultTradingBandwidth: 0,
};
exports.ParamsV280 = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.defaultLotSizeUsd !== "") {
            writer.uint32(10).string(message.defaultLotSizeUsd);
        }
        if (message.defaultTickSizeUsd !== "") {
            writer.uint32(18).string(message.defaultTickSizeUsd);
        }
        if (message.defaultMinQuantityUsd !== "") {
            writer.uint32(26).string(message.defaultMinQuantityUsd);
        }
        if (message.defaultSpotMakerFee !== "") {
            writer.uint32(34).string(message.defaultSpotMakerFee);
        }
        if (message.defaultSpotTakerFee !== "") {
            writer.uint32(42).string(message.defaultSpotTakerFee);
        }
        if (message.defaultFuturesMakerFee !== "") {
            writer.uint32(50).string(message.defaultFuturesMakerFee);
        }
        if (message.defaultFuturesTakerFee !== "") {
            writer.uint32(58).string(message.defaultFuturesTakerFee);
        }
        if (message.defaultRiskStepSizeUsd !== "") {
            writer.uint32(66).string(message.defaultRiskStepSizeUsd);
        }
        if (message.defaultInitialMarginBase !== "") {
            writer.uint32(74).string(message.defaultInitialMarginBase);
        }
        if (message.defaultInitialMarginStep !== "") {
            writer.uint32(82).string(message.defaultInitialMarginStep);
        }
        if (message.defaultMaintenanceMarginRatio !== "") {
            writer.uint32(90).string(message.defaultMaintenanceMarginRatio);
        }
        if (message.defaultMaxLiquidationOrderTicketUsd !== "") {
            writer.uint32(98).string(message.defaultMaxLiquidationOrderTicketUsd);
        }
        if (message.defaultMaxLiquidationOrderDuration !== undefined) {
            duration_1.Duration.encode(message.defaultMaxLiquidationOrderDuration, writer.uint32(106).fork()).ldelim();
        }
        if (message.defaultImpactSizeUsd !== "") {
            writer.uint32(114).string(message.defaultImpactSizeUsd);
        }
        if (message.defaultMarkPriceBand !== 0) {
            writer.uint32(120).uint32(message.defaultMarkPriceBand);
        }
        if (message.defaultLastPriceProtectedBand !== 0) {
            writer.uint32(128).uint32(message.defaultLastPriceProtectedBand);
        }
        if (message.maxActiveMarkets !== 0) {
            writer.uint32(136).uint32(message.maxActiveMarkets);
        }
        if (message.defaultTradingBandwidth !== 0) {
            writer.uint32(144).uint32(message.defaultTradingBandwidth);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseParamsV280);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.defaultLotSizeUsd = reader.string();
                    break;
                case 2:
                    message.defaultTickSizeUsd = reader.string();
                    break;
                case 3:
                    message.defaultMinQuantityUsd = reader.string();
                    break;
                case 4:
                    message.defaultSpotMakerFee = reader.string();
                    break;
                case 5:
                    message.defaultSpotTakerFee = reader.string();
                    break;
                case 6:
                    message.defaultFuturesMakerFee = reader.string();
                    break;
                case 7:
                    message.defaultFuturesTakerFee = reader.string();
                    break;
                case 8:
                    message.defaultRiskStepSizeUsd = reader.string();
                    break;
                case 9:
                    message.defaultInitialMarginBase = reader.string();
                    break;
                case 10:
                    message.defaultInitialMarginStep = reader.string();
                    break;
                case 11:
                    message.defaultMaintenanceMarginRatio = reader.string();
                    break;
                case 12:
                    message.defaultMaxLiquidationOrderTicketUsd = reader.string();
                    break;
                case 13:
                    message.defaultMaxLiquidationOrderDuration = duration_1.Duration.decode(reader, reader.uint32());
                    break;
                case 14:
                    message.defaultImpactSizeUsd = reader.string();
                    break;
                case 15:
                    message.defaultMarkPriceBand = reader.uint32();
                    break;
                case 16:
                    message.defaultLastPriceProtectedBand = reader.uint32();
                    break;
                case 17:
                    message.maxActiveMarkets = reader.uint32();
                    break;
                case 18:
                    message.defaultTradingBandwidth = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseParamsV280);
        message.defaultLotSizeUsd =
            object.defaultLotSizeUsd !== undefined &&
                object.defaultLotSizeUsd !== null
                ? String(object.defaultLotSizeUsd)
                : "";
        message.defaultTickSizeUsd =
            object.defaultTickSizeUsd !== undefined &&
                object.defaultTickSizeUsd !== null
                ? String(object.defaultTickSizeUsd)
                : "";
        message.defaultMinQuantityUsd =
            object.defaultMinQuantityUsd !== undefined &&
                object.defaultMinQuantityUsd !== null
                ? String(object.defaultMinQuantityUsd)
                : "";
        message.defaultSpotMakerFee =
            object.defaultSpotMakerFee !== undefined &&
                object.defaultSpotMakerFee !== null
                ? String(object.defaultSpotMakerFee)
                : "";
        message.defaultSpotTakerFee =
            object.defaultSpotTakerFee !== undefined &&
                object.defaultSpotTakerFee !== null
                ? String(object.defaultSpotTakerFee)
                : "";
        message.defaultFuturesMakerFee =
            object.defaultFuturesMakerFee !== undefined &&
                object.defaultFuturesMakerFee !== null
                ? String(object.defaultFuturesMakerFee)
                : "";
        message.defaultFuturesTakerFee =
            object.defaultFuturesTakerFee !== undefined &&
                object.defaultFuturesTakerFee !== null
                ? String(object.defaultFuturesTakerFee)
                : "";
        message.defaultRiskStepSizeUsd =
            object.defaultRiskStepSizeUsd !== undefined &&
                object.defaultRiskStepSizeUsd !== null
                ? String(object.defaultRiskStepSizeUsd)
                : "";
        message.defaultInitialMarginBase =
            object.defaultInitialMarginBase !== undefined &&
                object.defaultInitialMarginBase !== null
                ? String(object.defaultInitialMarginBase)
                : "";
        message.defaultInitialMarginStep =
            object.defaultInitialMarginStep !== undefined &&
                object.defaultInitialMarginStep !== null
                ? String(object.defaultInitialMarginStep)
                : "";
        message.defaultMaintenanceMarginRatio =
            object.defaultMaintenanceMarginRatio !== undefined &&
                object.defaultMaintenanceMarginRatio !== null
                ? String(object.defaultMaintenanceMarginRatio)
                : "";
        message.defaultMaxLiquidationOrderTicketUsd =
            object.defaultMaxLiquidationOrderTicketUsd !== undefined &&
                object.defaultMaxLiquidationOrderTicketUsd !== null
                ? String(object.defaultMaxLiquidationOrderTicketUsd)
                : "";
        message.defaultMaxLiquidationOrderDuration =
            object.defaultMaxLiquidationOrderDuration !== undefined &&
                object.defaultMaxLiquidationOrderDuration !== null
                ? duration_1.Duration.fromJSON(object.defaultMaxLiquidationOrderDuration)
                : undefined;
        message.defaultImpactSizeUsd =
            object.defaultImpactSizeUsd !== undefined &&
                object.defaultImpactSizeUsd !== null
                ? String(object.defaultImpactSizeUsd)
                : "";
        message.defaultMarkPriceBand =
            object.defaultMarkPriceBand !== undefined &&
                object.defaultMarkPriceBand !== null
                ? Number(object.defaultMarkPriceBand)
                : 0;
        message.defaultLastPriceProtectedBand =
            object.defaultLastPriceProtectedBand !== undefined &&
                object.defaultLastPriceProtectedBand !== null
                ? Number(object.defaultLastPriceProtectedBand)
                : 0;
        message.maxActiveMarkets =
            object.maxActiveMarkets !== undefined && object.maxActiveMarkets !== null
                ? Number(object.maxActiveMarkets)
                : 0;
        message.defaultTradingBandwidth =
            object.defaultTradingBandwidth !== undefined &&
                object.defaultTradingBandwidth !== null
                ? Number(object.defaultTradingBandwidth)
                : 0;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.defaultLotSizeUsd !== undefined &&
            (obj.defaultLotSizeUsd = message.defaultLotSizeUsd);
        message.defaultTickSizeUsd !== undefined &&
            (obj.defaultTickSizeUsd = message.defaultTickSizeUsd);
        message.defaultMinQuantityUsd !== undefined &&
            (obj.defaultMinQuantityUsd = message.defaultMinQuantityUsd);
        message.defaultSpotMakerFee !== undefined &&
            (obj.defaultSpotMakerFee = message.defaultSpotMakerFee);
        message.defaultSpotTakerFee !== undefined &&
            (obj.defaultSpotTakerFee = message.defaultSpotTakerFee);
        message.defaultFuturesMakerFee !== undefined &&
            (obj.defaultFuturesMakerFee = message.defaultFuturesMakerFee);
        message.defaultFuturesTakerFee !== undefined &&
            (obj.defaultFuturesTakerFee = message.defaultFuturesTakerFee);
        message.defaultRiskStepSizeUsd !== undefined &&
            (obj.defaultRiskStepSizeUsd = message.defaultRiskStepSizeUsd);
        message.defaultInitialMarginBase !== undefined &&
            (obj.defaultInitialMarginBase = message.defaultInitialMarginBase);
        message.defaultInitialMarginStep !== undefined &&
            (obj.defaultInitialMarginStep = message.defaultInitialMarginStep);
        message.defaultMaintenanceMarginRatio !== undefined &&
            (obj.defaultMaintenanceMarginRatio =
                message.defaultMaintenanceMarginRatio);
        message.defaultMaxLiquidationOrderTicketUsd !== undefined &&
            (obj.defaultMaxLiquidationOrderTicketUsd =
                message.defaultMaxLiquidationOrderTicketUsd);
        message.defaultMaxLiquidationOrderDuration !== undefined &&
            (obj.defaultMaxLiquidationOrderDuration =
                message.defaultMaxLiquidationOrderDuration
                    ? duration_1.Duration.toJSON(message.defaultMaxLiquidationOrderDuration)
                    : undefined);
        message.defaultImpactSizeUsd !== undefined &&
            (obj.defaultImpactSizeUsd = message.defaultImpactSizeUsd);
        message.defaultMarkPriceBand !== undefined &&
            (obj.defaultMarkPriceBand = message.defaultMarkPriceBand);
        message.defaultLastPriceProtectedBand !== undefined &&
            (obj.defaultLastPriceProtectedBand =
                message.defaultLastPriceProtectedBand);
        message.maxActiveMarkets !== undefined &&
            (obj.maxActiveMarkets = message.maxActiveMarkets);
        message.defaultTradingBandwidth !== undefined &&
            (obj.defaultTradingBandwidth = message.defaultTradingBandwidth);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s;
        const message = Object.assign({}, baseParamsV280);
        message.defaultLotSizeUsd = (_a = object.defaultLotSizeUsd) !== null && _a !== void 0 ? _a : "";
        message.defaultTickSizeUsd = (_b = object.defaultTickSizeUsd) !== null && _b !== void 0 ? _b : "";
        message.defaultMinQuantityUsd = (_c = object.defaultMinQuantityUsd) !== null && _c !== void 0 ? _c : "";
        message.defaultSpotMakerFee = (_d = object.defaultSpotMakerFee) !== null && _d !== void 0 ? _d : "";
        message.defaultSpotTakerFee = (_e = object.defaultSpotTakerFee) !== null && _e !== void 0 ? _e : "";
        message.defaultFuturesMakerFee = (_f = object.defaultFuturesMakerFee) !== null && _f !== void 0 ? _f : "";
        message.defaultFuturesTakerFee = (_g = object.defaultFuturesTakerFee) !== null && _g !== void 0 ? _g : "";
        message.defaultRiskStepSizeUsd = (_h = object.defaultRiskStepSizeUsd) !== null && _h !== void 0 ? _h : "";
        message.defaultInitialMarginBase = (_j = object.defaultInitialMarginBase) !== null && _j !== void 0 ? _j : "";
        message.defaultInitialMarginStep = (_k = object.defaultInitialMarginStep) !== null && _k !== void 0 ? _k : "";
        message.defaultMaintenanceMarginRatio =
            (_l = object.defaultMaintenanceMarginRatio) !== null && _l !== void 0 ? _l : "";
        message.defaultMaxLiquidationOrderTicketUsd =
            (_m = object.defaultMaxLiquidationOrderTicketUsd) !== null && _m !== void 0 ? _m : "";
        message.defaultMaxLiquidationOrderDuration =
            object.defaultMaxLiquidationOrderDuration !== undefined &&
                object.defaultMaxLiquidationOrderDuration !== null
                ? duration_1.Duration.fromPartial(object.defaultMaxLiquidationOrderDuration)
                : undefined;
        message.defaultImpactSizeUsd = (_o = object.defaultImpactSizeUsd) !== null && _o !== void 0 ? _o : "";
        message.defaultMarkPriceBand = (_p = object.defaultMarkPriceBand) !== null && _p !== void 0 ? _p : 0;
        message.defaultLastPriceProtectedBand =
            (_q = object.defaultLastPriceProtectedBand) !== null && _q !== void 0 ? _q : 0;
        message.maxActiveMarkets = (_r = object.maxActiveMarkets) !== null && _r !== void 0 ? _r : 0;
        message.defaultTradingBandwidth = (_s = object.defaultTradingBandwidth) !== null && _s !== void 0 ? _s : 0;
        return message;
    },
};
if (minimal_1.default.util.Long !== long_1.default) {
    minimal_1.default.util.Long = long_1.default;
    minimal_1.default.configure();
}
